import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";

import InteractiveImageViewer from "../../InteractiveImageViewer";
import SpinLoader from "../../SpinLoader";

import { getIleggelseBildeBase64 } from "../../../../actions/ileggelserActions";

const spinnerLoaderProps = {
  height: 42,
  width: 42,
  thickness: 3,
  pColor: "#ffffff",
  sColor: "#4d4d4d",
};

const IleggelseOrginalbilde = () => {
  const { id, bildeId } = useParams();
  const [bilde, setBilde] = useState(undefined);
  const [showSpinner, setShowSpinner] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    setShowSpinner(true);
    dispatch(getIleggelseBildeBase64(id, bildeId))
      .then((result) => {
        setShowSpinner(false);
        setBilde(result);
      })
      .catch(() => setShowSpinner(false));
  }, [dispatch, id, bildeId]);

  if (showSpinner) {
    return (
      <div style={{ margin: "auto", paddingTop: 50, width: 0 }}>
        <SpinLoader {...spinnerLoaderProps} />
      </div>
    );
  }

  if (!bilde?.src) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontSize: "18px",
          color: "#666",
        }}
      >
        Image not found
      </div>
    );
  }

  return (
    <InteractiveImageViewer
      imageSrc={bilde.src}
      imageAlt="Ileggelse - orginalbilde"
      showControls={true}
      backgroundColor="transparent"
    />
  );
};

export default IleggelseOrginalbilde;
